import { render, staticRenderFns } from "./ApprovalStatusTemplate.vue?vue&type=template&id=d8ffb14e"
import script from "./ApprovalStatusTemplate.vue?vue&type=script&lang=ts"
export * from "./ApprovalStatusTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8ffb14e')) {
      api.createRecord('d8ffb14e', component.options)
    } else {
      api.reload('d8ffb14e', component.options)
    }
    module.hot.accept("./ApprovalStatusTemplate.vue?vue&type=template&id=d8ffb14e", function () {
      api.rerender('d8ffb14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ApprovalStatusTemplate/ApprovalStatusTemplate.vue"
export default component.exports